var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[ 'spinner-holder', { active: _vm.active, primary: _vm.primary } ],style:({
		width: `${_vm.size}px!important`,
		height: `${_vm.size}px!important`,
	})},[_c('div',{class:[ 'spinner-wrapper', { fill: _vm.fill } ],style:({
			borderWidth: `${_vm.width - 1}px!important`,
		})},[_c('svg',{staticClass:"spinner",style:({
				width: `${_vm.size + 2}px!important`,
				height: `${_vm.size + 2}px!important`,
				top: _vm.top,
				left: _vm.left
			}),attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":_vm.width + 1}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }